<script>
export default {
	name: 'AeroDaratArticleLayout',
	expose: [],
	inheritAttrs: false,
};
</script>


<script setup>
import dayjs from 'dayjs';
import ExperienceFragment from '~/aem-components/ExperienceFragment.vue';
import Breadcrumb from '~/components/Breadcrumb.vue';
import { useGlobalAEMState } from '~/logic/aem/global-aem-state.js';
import BtnBackToTop from '~/components/BtnBackToTop.vue';
import { generateXfPath } from '@/logic/aem/generate-xf-path';


const { pageProperties } = useGlobalAEMState();
const siteName = window.siteName;

const articleTitle = computed(() => {
	if (!pageProperties.value?.articlePageProperties?.articlePageTitle) return null;
	return pageProperties.value.articlePageProperties.articlePageTitle;
});
const articleDate = computed(() => {
	if (!pageProperties.value?.articlePageProperties?.articleDate) return null;
	return dayjs(pageProperties.value.articlePageProperties.articleDate).format('DD MMM YYYY');
});
const articleTags = computed(() => {
	if (!pageProperties.value?.articlePageProperties?.categoryTags) return '';
	return pageProperties.value.articlePageProperties.categoryTags.map((tag) => tag.title).join(', ');
});

</script>


<template>
<div class="AeroDaratArticleLayout flex flex-col min-h-screen" data-layout="AeroDaratArticle">
	
	<ExperienceFragment
		class="global-header"
		xfPath="/content/experience-fragments/ads/$country/$lang/site/header/master"
		:disableTransparency="true"
	/>
	
	<!-- Only for this layout, header spacer -->
	<div class="sticky-spacer h-$headerHeight"></div>
	
	<div id="content"></div>
	<div id="booking-subpage-container"></div>
	
	<main>
		<div class="flex items-center z-20 bg-neutral-grey-ultralight py-5">
			<div class="generic-container">
				<Breadcrumb />
			</div>
		</div>
		
		<div class="generic-container my-12">
			<h1 v-if="articleTitle" class="heading-2 mb-5">
				{{ articleTitle }}
			</h1>
			<div class="text-primary-blue-base font-medium uppercase">
				<time v-if="articleDate" class="article-date" dir="ltr">
					{{ articleDate }}
				</time>
				<template v-if="articleTags">
					<span class="px-2">|</span>
					<span
						class="article-category"
					>
						{{ articleTags }}
					</span>
				</template>
			</div>
		</div>
		
		<slot></slot>
	</main>
	
	<div class="floating-bottom-right-container">
		<BtnBackToTop />
	</div>
	
	<ExperienceFragment
		class="global-cookies-notification"
		:xfPath="generateXfPath({ siteName, xfComponentId: 'cookies-notification' })"
	/>
	<ExperienceFragment
		class="global-footer"
		xfPath="/content/experience-fragments/ads/$country/$lang/site/footer/master"
	/>
</div>
</template>


<style scoped lang="scss">
@use '~/styles/partials/_var.scss';

:slotted(.page) {
	min-height: 400px;
}

</style>
